module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logoutPage"
    }
  }, [_vm._v("\n" + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b834834", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b834834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
// module id = 680
// module chunks = 0